// extracted by mini-css-extract-plugin
module.exports = {"page":"style_page__TItb5","loading":"style_loading__tqfHG","mobile-nav":"style_mobile-nav___WlC3"};